function FeatureIconContainer({
  children,
  childIconSize = 16,
  radiusClass = "rounded-lg",
  bgColorClass = ""
}: {
  children: React.ReactNode;
  childIconSize?: number;
  radiusClass?: "rounded" | "rounded-md" | "rounded-lg" | "rounded-full";
  bgColorClass?: string;
}) {
  const containerDimension = childIconSize * 1.8;

  return (
    <div
      className={`rounded-lg flex items-center justify-center relative overflow-hidden ${radiusClass} ${bgColorClass}`}
      style={{
        width: containerDimension,
        height: containerDimension
      }}
    >
      {children}
    </div>
  );
}

export default FeatureIconContainer;
